import React from 'react';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import Event from './Event';
import uniqBy from 'lodash/uniqBy';

function getComputedEvents(listEvents, nhours) {
  const sortedEvents = orderBy(listEvents, ['start','startdate'], ['asc', 'desc']);
  const events = uniqBy(sortedEvents, x => x.slug+' '+x.time);
  
  let computedEvents = [];

  function getContainerWidth(event){
    if (computedEvents.length === 0) {
      return 1;
    }

    for (var j = 0, m = computedEvents.length; j < m; j++) {
      var r = computedEvents[j];
      if (event.start < r.end) {
        return r.left;
      }
    }

    return 1;
  }

  while (events.length > 0) {
    let e = events.shift();

    // Find overlapping events.
    let overlappingEvents = [e];
    while (events.length > 0 && e.start <= events[0].start && e.end > events[0].start) {
      overlappingEvents.push(events.shift());
    }

    // The container's width is the maximun space that we can use to render the
    // overlapping events.
    let containerWidth = getContainerWidth(e, computedEvents);

    let width = containerWidth / overlappingEvents.length;
    computedEvents.push(...map(overlappingEvents, (oe, i) => {
      return {
        ...oe,
        width,
        height: (oe.end - oe.start)/nhours,
        top: oe.start/nhours,
        left: width * i
      };
    }));
  }
  return computedEvents;
}

const Day = ({events, isFavoriteClass, courses, nhours}) => {
  return (
    <div>
      <div className="dayContainer">
        {
          map(getComputedEvents(events, nhours), (e, i) => {
            return <Event key={`event-${i}`} {...e} isFavoriteClass={isFavoriteClass} courses={courses} />;
          })
        }
      </div>
    </div>
  );
}

export default Day;



// WEBPACK FOOTER //
// ./src/components/common/Calendar/Day.js